import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading, selectSaving, selectSaved, selectError, selectReflection, selectCreatedId, selectLoaded } from '../selectors/reflection.selector';
import { reflectionActions } from '../actions/reflection.actions';
import { ReflectionValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ReflectionFacade {
    private store = inject(Store);

    readonly reflection = (id: string) => this.store.selectSignal(selectReflection(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));
    readonly loaded = (id: string) => this.store.selectSignal(selectLoaded(id));
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = (id: string) => this.store.selectSignal(selectError(id));
    readonly createdId = this.store.selectSignal(selectCreatedId);

    getReflection(id: string): void {
        this.store.dispatch(reflectionActions.getReflection({ id }));
    }

    createReflection(value: ReflectionValue): void {
        this.store.dispatch(reflectionActions.createReflection({ value }));
    }

    updateReflection(id: string, value: ReflectionValue): void {
        this.store.dispatch(reflectionActions.updateReflection({ id, value }));
    }

    deleteReflection(id: string): void {
        this.store.dispatch(reflectionActions.deleteReflection({ id }));
    }

    clear(): void {
        this.store.dispatch(reflectionActions.clear());
    }
}
